import { useState } from 'react';
import { Link } from 'react-router-dom';

const featuredCards = [
  {
    id: 'article-1',
    slug: 'dingzhen-chugui-baoguang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20nighttime%20scene%20outside%20a%20luxury%20hotel%20in%20Beijing%20with%20paparazzi%20atmosphere%20dim%20lighting%20a%20luxury%20car%20parked%20near%20the%20entrance%20mysterious%20silhouettes%20cinematic%20moody%20tones%20editorial%20photography%20style%20with%20soft%20shadows%20and%20rich%20contrast&width=600&height=800&seq=featured-article-dingzhen&orientation=portrait',
    tag: '出轨',
    title: '某知名男星深夜密会神秘女子，酒店共度8小时，出轨实锤曝光',
    excerpt: '据知情人士透露，该男星与妻子结婚仅两年，此次被拍到与一名年轻女子深夜进入某五星级酒店，直到次日清晨才离开。',
  },
  {
    id: 'article-2',
    slug: 'wanghong-zhibo-fanche',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20influencer%20livestreaming%20in%20a%20bright%20studio%20filled%20with%20products%20shocked%20expression%20on%20face%20dramatic%20moment%20phone%20screens%20showing%20angry%20comments%20warm%20lighting%20modern%20livestream%20setup%20editorial%20photography%20high%20detail%20cinematic%20mood&width=600&height=800&seq=featured-article-livestream&orientation=portrait',
    tag: '直播翻车',
    title: '千万粉丝网红直播带货翻车，假货被当场拆穿，场面一度失控',
    excerpt: '该网红在直播间声称销售的是"正品大牌"，却被消费者当场拿出专柜鉴定报告打脸，直播间评论区瞬间炸锅。',
  },
  {
    id: 'article-3',
    slug: 'nvyouxing-zhengrong-fengbo',
    imageUrl: 'https://readdy.ai/api/search-image?query=Split%20comparison%20style%20image%20showing%20dramatic%20before%20and%20after%20beauty%20transformation%20elegant%20woman%20in%20soft%20lighting%20beauty%20clinic%20aesthetic%20editorial%20photography%20minimal%20background%20with%20warm%20tones%20sophisticated%20composition&width=600&height=800&seq=featured-article-plastic&orientation=portrait',
    tag: '整容',
    title: '当红女星整容前后对比照流出，面部变化惊人，粉丝直呼认不出',
    excerpt: '有网友扒出该女星出道前的素颜照与近期活动照进行对比，鼻子、下巴、眼睛等部位变化明显，引发整容质疑。',
  },
];

export default function FeaturedGrid() {
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  return (
    <section className="w-full bg-background-50 py-14 md:py-18 lg:py-20">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-950 mb-2">
            热门专题 <span className="inline-block" role="img" aria-label="fire">🔥</span>
          </h2>
          <p className="text-sm text-foreground-500">全网最火爆的爆料专题，吃瓜必看</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {featuredCards.map((card) => (
            <Link
              key={card.id}
              to={`/article/${card.slug}`}
              className={`relative group overflow-hidden rounded-lg cursor-pointer transition-all duration-500 ${
                hoveredId === card.id ? 'md:col-span-2' : 'md:col-span-1'
              }`}
              style={{ aspectRatio: hoveredId === card.id ? undefined : '3/4' }}
              onMouseEnter={() => setHoveredId(card.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <img
                src={card.imageUrl}
                alt={card.title}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                <span className="inline-block px-2.5 py-1 bg-accent-500 text-white text-xs font-medium rounded-full mb-3">
                  {card.tag}
                </span>
                <h3 className="text-lg md:text-xl font-heading text-white mb-2 line-clamp-2">
                  {card.title}
                </h3>
                <p className={`text-sm text-white/70 leading-relaxed transition-all duration-500 ${
                  hoveredId === card.id ? 'opacity-100 max-h-20' : 'opacity-0 max-h-0 overflow-hidden'
                }`}>
                  {card.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}